import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M5 3.5C5 2.11929 6.11929 1 7.5 1H16.5C17.8807 1 19 2.11929 19 3.5V20.5C19 21.8807 17.8807 23 16.5 23H7.5C6.11929 23 5 21.8807 5 20.5V3.5ZM9.5 20C9.22386 20 9 20.2239 9 20.5C9 20.7761 9.22386 21 9.5 21H14.5C14.7761 21 15 20.7761 15 20.5C15 20.2239 14.7761 20 14.5 20H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhone;
